import React from "react";
import handleCondition from "./handleConditionOnQuestion";
import * as FormsComponent from "../../../components/Inputs/index";
import classNames from "classnames";
import ReactPlayer from 'react-player'
import { CheckCircleIcon } from "@heroicons/react/24/solid";

function handleComponentSelection(question, errorQ, onDataChange) {
  const { t } = this.props;
  switch (question.fieldType) {
    case "html":
    case "text":
      return (
        <FormsComponent.Input
          id={question.name}
          key={question.id}
          type="text"
          readOnly={question.readOnly}
          placeholder={t("Response")}
          value={
            this.state.formData && this.state.formData[question.name]
              ? this.state.formData[question.name]
              : ""
          }
          onChange={(value) => {
            var formData = this.state.formData;
            formData[question.name] = value;
            this.setState({ formData });
            onDataChange(formData, question)
          }}
          error={errorQ}
        />
      );
    case "phonenumber":
      return <FormsComponent.PhoneInput key={question.id}
        id={question.name}
        readOnly={question.readOnly}
        type="number"
        value={
          this.state.formData && this.state.formData[question.name] !== null
            ? this.state.formData[question.name]
            : ""
        }
        onChange={(value) => {
          var formData = this.state.formData;
          formData[question.name] = value;
          this.setState({ formData });
          onDataChange(formData, question)
        }}
        error={errorQ} />;
    case "number":
    case "NumberPicker":
      return (
        <FormsComponent.Input
          key={question.id}
          id={question.name}
          readOnly={question.readOnly}
          type="number"
          value={
            this.state.formData && this.state.formData[question.name] !== null
              ? this.state.formData[question.name]
              : 0
          }
          onChange={(value) => {
            var formData = this.state.formData;
            formData[question.name] = value;
            if (value.startsWith(0)) {
              formData[question.name] = value.split('0')[1];
            }
            if (!value) {
              formData[question.name] = 0
            }
            this.setState({ formData });
            onDataChange(formData, question)
          }}
          error={errorQ}
        />
      );
    case "file":
      return (
        <FormsComponent.FileUpload
          id={question.name}
          key={question.id}
          readOnly={question.readOnly}
          formId={this.props.formId} candidature={this.props.candidature} contactId={this.props.contactId} templateId={this.props.templateId} questionId={question.id}
          secondaryObjects={this.props.secondaryObjects}
          placeholder={t("Response")}
          onChange={(value) => {
            var formData = this.state.formData;
            formData[question.name] = value;
            this.setState({ formData });
            onDataChange(formData, question)
          }}
          value={
            this.state.formData && this.state.formData[question.name]
              ? this.state.formData[question.name]
              : null
          }
          msalInstance={this.props.msalInstance}
          error={errorQ}
        />
      );
    case "date":
      return (
        <FormsComponent.DatePicker
          id={question.name}
          key={question.id}
          readOnly={question.readOnly}
          placeholder={t("Response")}
          value={
            this.state.formData && this.state.formData[question.name]
              ? this.state.formData[question.name]
              : ""
          }
          onChange={(value) => {
            var formData = this.state.formData;
            formData[question.name] = value;
            this.setState({ formData });
            onDataChange(formData, question)
          }}
          error={errorQ}
        />
      );
    case "DateTimePicker":
      return (
        <FormsComponent.DateTimePicker
          id={question.name}
          key={question.id}
          readOnly={question.readOnly}
          placeholder={t("Response")}
          value={
            this.state.formData && this.state.formData[question.name]
              ? this.state.formData[question.name]
              : ""
          }
          onChange={(value) => {
            var formData = this.state.formData;
            formData[question.name] = value;
            this.setState({ formData });
            onDataChange(formData, question)
          }}
          error={errorQ}
        />
      );
    case "timePicker":
      return (
        <FormsComponent.TimePicker
          id={question.name}
          key={question.id}
          readOnly={question.readOnly}
          placeholder={t("Response")}
          value={
            this.state.formData && this.state.formData[question.name]
              ? this.state.formData[question.name]
              : ""
          }
          onChange={(value) => {
            var formData = this.state.formData;
            formData[question.name] = value;
            this.setState({ formData });
            onDataChange(formData, question)
          }}
          error={errorQ}
        />
      );
    case "textarea":
      return (
        <FormsComponent.TextArea
          id={question.name}
          key={question.id}
          readOnly={question.readOnly}
          placeholder={t("Response")}
          rows="4"
          value={
            this.state.formData && this.state.formData[question.name]
              ? this.state.formData[question.name]
              : ""
          }
          onChange={(value) => {
            var formData = this.state.formData;
            formData[question.name] = value;
            this.setState({ formData });
            onDataChange(formData, question)
          }}
          error={errorQ}
        />
      );
    case "switch":
      return (
        <FormsComponent.Switch
          key={question.id}
          value={
            this.state.formData && this.state.formData[question.name]
              ? this.state.formData[question.name]
              : false
          }
          readOnly={question.readOnly}
          onChange={(value) => {
            var formData = this.state.formData;
            formData[question.name] = value;
            this.setState({ formData });
            onDataChange(formData, question)
          }}
        />
      );
    case "slider":
      return (
        <FormsComponent.Slider
          id={question.name}
          key={question.id}
          readOnly={question.readOnly}
          min={question.min}
          max={question.max}
          value={
            this.state.formData &&
              (this.state.formData[question.name] ||
                this.state.formData[question.name] === 0)
              ? this.state.formData[question.name]
              : Math.trunc((question.min + question.max) / 2)
          }
          onChange={(newValue) => {
            var formData = this.state.formData;
            formData[question.name] = newValue;
            this.setState({ formData });
            onDataChange(formData, question)
          }}
          {...question.componentParameter}
        />
      );
    case "radio":
    case "select": {
      const selectOptions = question.options?.filter(opt => question.optionsCustom ? question.optionsCustomList.find(o => o === opt.value) : true) ?? [];
      const usePills = !question.readOnly && selectOptions.length > 0 && selectOptions.length < 3;
      const singleOption = !question.readOnly && selectOptions.length === 1;
      return (
        question.optionsCustomList?.length > 0 || question.options?.length > 0 ? (
          <div key={question.name}>
            {question.readOnly ? <FormsComponent.Input
              id={question.name}
              type="text"
              readOnly={true}
              placeholder={t("Response")}
              lang="fr"
              translate="yes"
              value={question.optionsCustomList?.length > 0 || question.options?.length > 0 ?
                question.optionsCustomList.length === 1 ? question.optionsCustomList[0] : question.value && question?.options.find(opt => opt.value.toString() === question.value.toString()) ? question?.options.find(opt => opt.value.toString() === question.value.toString())?.label : "" : null}
            /> : singleOption ? (
              <FormsComponent.Checkbox
                value={this.state.formData[question.name] === selectOptions[0].value}
                onChange={(e) => {
                  var formData = this.state.formData;
                  formData[question.name] = e.target.checked ? selectOptions[0].value : null;
                  this.setState({ formData });
                  onDataChange(formData, question);
                }}
                optionLabel={selectOptions[0].label}
              />
            ) : usePills ? (
              <FormsComponent.RadioCheckbox
                options={selectOptions.map(opt => ({ value: opt.value, label: opt.label }))}
                value={this.state.formData && this.state.formData[question.name] ? this.state.formData[question.name] : null}
                onChange={(value) => {
                  var formData = this.state.formData;
                  formData[question.name] = value;
                  this.setState({ formData });
                  onDataChange(formData, question);
                }}
                keyName={question.name}
              />
            ) : (
              <select className="block w-full text-sm bg-white border border-primary rounded-[11px] h-[46px] px-3.5 focus:outline-none transition-colors"
                name={question.name}
                lang="fr"
                translate="yes"
                onChange={(e) => {
                  var formData = this.state.formData;
                  formData[question.name] = e.target.value;
                  this.setState({ formData });
                  onDataChange(formData, question)
                }}
                value={this.state.formData[question.name]}>
                <option value=""></option>
                {selectOptions.map(opt => <option key={opt.value} value={opt.value} lang="fr" translate="yes">{opt.label}</option>)}
              </select>
            )}
          </div>
        ) : <div>
          <span className="text-sm">
            Un problème à eu lieu lors de la récupération de {question.label}.
          </span>
        </div>
      );
    }
    case "booleancheckbox":
      return (
        <div key={question.name}>
          <FormsComponent.RadioCheckbox
            options={question.options ? question.options.map((option) => { return { value: option.value, label: option.label } }) : []}
            value={this.state.formData && this.state.formData[question.name] ? this.state.formData[question.name] : null}
            onChange={(value) => {
              var formData = this.state.formData;
              formData[question.name] = value;
              this.setState({ formData });
              onDataChange(formData, question);
            }}
            keyName={question.name}
          ></FormsComponent.RadioCheckbox>
        </div>
      )
    case "selectMultiple":
    case "checkbox":
      return (
        <FormsComponent.SelectMultiple
          key={question.name}
          readOnly={question.readOnly}
          id={question.name}
          value={
            this.state.formData && this.state.formData[question.name]
              ? this.state.formData[question.name]
              : null
          }
          keys={
            this.state.formData && this.state.formData[question.name]
              ? this.state.formData[question.name]
              : null
          }
          onChange={(value) => {
            var formData = this.state.formData;
            formData[question.name] = value;
            this.setState({ formData });
            onDataChange(formData, question)
          }}
          options={
            question.options
              ? question.options.map((option, index) => {
                return { key: index, id: option.value, label: option.label, value: option.value };
              })
              : []
          }
        />
      );
    case "selected":
      return (
        <div key={question.id}>
          <div>
            {this.state.formData && this.state.formData[question.name]
              ? typeof this.state.formData[question.name] !== "object"
                ? this.state.formData[question.name + "name"]
                : this.state.formData[question.name + "name"]
              : null}
          </div>
        </div>
      );
    default:
      return process.env.NODE_ENV === "development" ? <>NOT IMPLEMENTED :{question.component} , {question.fieldType}, {JSON.stringify(question)}</> : null;
  }
}

function getQuestionRender(question, key) {
  if (handleCondition(this.state.formData, question, this.props.form)) {
    let handleComponent = handleComponentSelection.bind(this);
    let getQRender = getQuestionRender.bind(this);
    if (question.fieldType === "custom input") {
      switch (question.object) {
        case "Image":
          return <div key={key} className="md:col-span-2"><img
            className={classNames(key === 0 ? "" : "mt-4", "right-0 w-full h-auto xl:mx-auto xl:max-w-[33vw] ")}
            src={question.value}
            alt={question.value}
          /></div>
        case "Video":
          return <div key={key} className="md:col-span-2 mx-auto w-full">
            <ReactPlayer url={question.value} width="xs:90vw md:33vw" />
          </div>
        case "Title":
        case "Titre":
        case "Texte":
          if (this.state.questionPaybox && !this.state.questionPayboxshow) {
            return <div key={key} className="md:col-span-2 mt-6">
              <FormsComponent.Alert type="success" description={<span lang="fr" translate="yes">{question.value}</span>} />
            </div>
          } else {
            return <div key={key} className="md:col-span-2 pt-4 pb-1">
              <h3 className="text-xl font-bold text-gray-900" lang="fr" translate="yes">{question.value}</h3>
            </div>
          } case "Description":
          if (this.state.questionPaybox && !this.state.questionPayboxshow) {
            return <div key={key} className="md:col-span-2 p-4 mt-6 bg-green-100/70">
              <div className="flex">
                <div className="shrink-0">
                  <CheckCircleIcon aria-hidden="true" className="size-5 text-green-400" />
                </div>
                <div className="ml-3">
                  <div className="mt-2 text-sm" style={{ whiteSpace: "pre-line" }} lang="fr" translate="yes">
                    {question.value}
                  </div>
                </div>
              </div>
            </div>
          } else {
            return <div key={key} className="md:col-span-2 mb-4 text-sm text-gray-500" style={{ whiteSpace: "pre-line" }} lang="fr" translate="yes">{question.value}</div>
          }
        case "Stripe":
          return <div key={key} className="md:col-span-2"><FormsComponent.Stripe question={question} dealId={this.props.dealId} formId={this.props.formId} /></div>
        case "Paybox":
          return <div key={key} className="md:col-span-2"><FormsComponent.Paybox question={question} dealId={this.props.dealId} formId={this.props.formId} /></div>
        case "Address":
          return <div key={key} className="md:col-span-2"><FormsComponent.Address question={question} form={this.props.form} formData={this.state.formData} onDataChange={this.onDataChange} schema={this.schema} errors={this.state.errors} /></div>
        case "Recap":
          return <div key={key} className="md:col-span-2"><FormsComponent.Recap question={question} currentStep={this.props.currentStep} setStep={this.props.setStep} formData={this.state.formData} /></div>
        case "Redirect":
          return <div key={key} className="md:col-span-2 cursor-pointer font-semibold" onClick={() => { window.open(question.value, "_blank") }} lang="fr" translate="yes">{question.label}</div>
        case "Logic block":
        case "Logic":
          return null
        default:
          return process.env.NODE_ENV === "development" ? <>Not implemented : {question.object}, {JSON.stringify(question)}</> : null
      }
    } else if (question.fieldType === "custom variable") {
      return null;
    } else if (question.subfieldType === "url") {
      return <FormsComponent.Url key={key} label={question.label} value={question.value} />
    } else {
      let halfWidth = ["text", "number", "NumberPicker", "date", "DateTimePicker", "timePicker", "select", "radio"].includes(question.fieldType);
      if (halfWidth && (question.fieldType === "select" || question.fieldType === "radio")) {
        const selectOptions = question.options?.filter(opt => question.optionsCustom ? question.optionsCustomList.find(o => o === opt.value) : true) ?? [];
        const usePills = !question.readOnly && selectOptions.length > 0 && selectOptions.length < 3;
        const singleOption = !question.readOnly && selectOptions.length === 1;
        if (usePills || singleOption) halfWidth = false;
      }
      return (
        <FormsComponent.Question
          key={key}
          {...question}
          value={this.state.formData[question.name] ? this.state.formData[question.name] : null}
          schema={this.schema}
          title={question.label}
          msalInstance={this.props.msalInstance}
          pressSubmitOnce={this.state.pressSubmitOnce}
          errors={this.state.errors}
          className={halfWidth ? "" : "md:col-span-2"}
        >
          {errorL => <>
            <div key={key + "handleComponent"} className="">{handleComponent(question, errorL, this.onDataChange)}</div>
            <div key={key + "subQuestions"}>{question.subQuestions
              ? question.subQuestions.map((sb, sbKey) => {
                return getQRender(sb, sbKey);
              })
              : ""}</div>
          </>}
        </FormsComponent.Question>
      );
    }
  } else {
    return "";
  }
}



function verifyDependance(question) {
  return question.sub;
}

function initResponse(question) {
  if (question.value != null) {
    switch (question.widget) {
      case "datePicker":
        return new Date(question.value);
      default:
        return question.value;
    }
  }
  switch (question.widget) {
    case "Slider":
      return Math.trunc((question.min + question.max) / 2);
    case "Switch":
      return false;
    case "datePicker":
      return new Date();
    default:
      return "";
  }
}

export {
  initResponse,
  handleComponentSelection,
  verifyDependance,
  getQuestionRender
};
